import _ from 'lodash'

export const changedKeys = (o1: Record<any, any>, o2: Record<any, any>) => {
	const keys = _.union(_.keys(o1), _.keys(o2));
	return _.filter(keys, function (key) {
		return o1[key] !== o2[key];
	});
};

export const compactObject = _.partialRight(_.omit, _.isUndefined);